
import bildDreiMonate from '@/assets/icons/zeit_3_monate.svg';
import bildSechsMonate from '@/assets/icons/zeit_6_monate.svg';
import bildMehrAlsSechsMonate from '@/assets/icons/zeit_6+_monate.svg';


export const plannedReplacements = [
    { name: 'Innerhalb von 3 Monaten', available: true, value: 'thee_months', api: '20306', image: bildDreiMonate },
    { name: 'Innerhalb von 6 Monaten', available: true, value: 'six_months', api: '20307', image: bildSechsMonate },
    { name: 'In 6 Monaten oder später', available: true, value: 'six_months_and_more', api: '20308', image: bildMehrAlsSechsMonate },

];

export const plannedReplacementApi = {parameter: '17547', type: 'value_choice'}

